import React from 'react'

export default function Section4() {
  return (
    <div className='px-3 lg:px-0'>
      <p className='text-center custom-font text-4xl py-10'>CRYPWALLET <span className='text-[#0500ff]'>Features</span></p>
      <div className='flex flex-col gap-4 lg:flex-row justify-center lg:gap-10 PY-5'>
        <div className='lg:w-[25%] bg-white rounded-3xl shadow-2xl px-3 py-2'>
          <div className='flex justify-center'>
            <img className='w-8/12' src='/assets/img/human.svg'></img>
          </div>
          <div className='mt-2 flex flex-col gap-3'>
            <h3 className='text-black custom-font text-left text-md'>Private & Secure</h3>
            <p className='text-[#696871] font-normal text-left leading-8'>Create wallets <strong>without sharing personal details</strong>, ensuring <strong> privacy and full ownership.</strong></p>
          </div>
        </div>
        <div className='lg:w-[25%] bg-white rounded-3xl shadow-2xl px-3 py-2'>
          <div className='flex justify-center'>
            <img className='w-7/12' src='/assets/img/human2.svg'></img>
          </div>
          <div className='mt-2 flex flex-col gap-3'>
            <h3 className='text-black custom-font text-left '>Advanced Encryption</h3>
            <p className='text-[#696871] font-normal text-left leading-8'>Protected by <strong>MFA, biometric login, and top-tier encryption</strong> for ultimate security.</p>
          </div>
        </div>
        <div className='lg:w-[25%] bg-white rounded-3xl shadow-2xl px-3 py-4'>
          <div className='flex justify-center'>
            <img className='w-8/12' src='/assets/img/human3.svg'></img>
          </div>
          <div className='mt-2 flex flex-col gap-3'>
            <h3 className='text-black custom-font text-left text-md'>Easy Recovery</h3>
            <p className='text-[#696871] font-normal text-left leading-8'>Regain access anytime, ensuring <strong>you never lose control of your assets</strong>.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
